import { getNotificationContext } from "@diana-ui/notification";
import { ICustomNotification as INotification } from "./NotificationStack";

export const NotificationContext = getNotificationContext<INotification>();
export const {
  Provider: NotificationProvider,
  Consumer: NotificationConsumer
} = NotificationContext;
